angular.module('picmonicng').directive('expandOnFocus', [
  function () {
    return {
      restrict: 'A',
      scope: {},
      link: function (scope, element, attrs) {
        var originalWidth = element.width(),
          originalHeight = element.height();

        element.on('focusin', function (e) {
          element.animate({
            width: originalWidth * 2,
            height: originalHeight * 2,
          });
        });

        element.on('focusout', function (e) {
          element.animate({
            width: originalWidth,
            height: originalHeight,
          });
        });
      },
    };
  },
]);
